import { ReactNode } from 'react';
import type { FormModel } from '../model/types';

export function Form<TCtx>({
  form,
  className,
  children,
  onSubmit,
}: {
  form: FormModel<TCtx>;
  className?: string;
  children?: ReactNode;
  onSubmit?: (finalModel: TCtx) => Promise<void> | void;
}) {
  return (
    <form
      className={className}
      onSubmit={async (e) => {
        e.preventDefault();
        await form.submit(async (finalModel: TCtx) => {
          if (onSubmit) await onSubmit(finalModel);
        });
      }}
    >
      {children}
    </form>
  );
}
